export function createEmptyTotalSelectedInvoiceData() {
  return {
    totalTaxBase: 0,
    totalDiscount: 0,
    totalAmount: 0,
    totalTaxes: 0,
    totalIrpf: 0,
    totalTax21: 0,
    totalTax10: 0,
    totalTax4: 0,
    totalIrpf19: 0,
    totalIrpf15: 0,
    totalIrpf7: 0,
    totalIrpf2: 0,
    totalIrpf1: 0,
  };
}

export function generateCalculatedTotalSelectedInvoice(invoice) {
  let totalSelectedInvoiceData = createEmptyTotalSelectedInvoiceData();
  invoice.order_items.forEach(item => {
    // Total tax base
    let totalTaxBase = parseFloat(totalSelectedInvoiceData.totalTaxBase);
    totalSelectedInvoiceData.totalTaxBase = (totalTaxBase + parseFloat(item.total_amount)).toFixed(
      2,
    );

    // Total discounts
    if (item.discount_amount) {
      let totalDiscount = parseFloat(totalSelectedInvoiceData.totalDiscount);
      let discount =
        item.discount_type === 'percentage'
          ? (item.tax_base * item.discount_amount) / 100
          : item.discount_amount;
      totalSelectedInvoiceData.totalDiscount = (totalDiscount + parseFloat(discount)).toFixed(2);
    }

    // Total TAX 21%
    if (item.tax === '21') {
      let totalTax21 = parseFloat(totalSelectedInvoiceData.totalTax21);
      totalSelectedInvoiceData.totalTax21 = (
        totalTax21 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total TAX 10%
    if (item.tax === '10') {
      let totalTax10 = parseFloat(totalSelectedInvoiceData.totalTax10);
      totalSelectedInvoiceData.totalTax10 = (
        totalTax10 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total TAX 4%
    if (item.tax === '4') {
      let totalTax4 = parseFloat(totalSelectedInvoiceData.totalTax4);
      totalSelectedInvoiceData.totalTax4 = (
        totalTax4 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 19%
    if (item.irpf === '19') {
      let totalIrpf19 = parseFloat(totalSelectedInvoiceData.totalIrpf19);
      totalSelectedInvoiceData.totalIrpf19 = (
        totalIrpf19 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 15%
    if (item.irpf === '15') {
      let totalIrpf15 = parseFloat(totalSelectedInvoiceData.totalIrpf15);
      totalSelectedInvoiceData.totalIrpf15 = (
        totalIrpf15 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 7%
    if (item.irpf === '7') {
      let totalIrpf7 = parseFloat(totalSelectedInvoiceData.totalIrpf7);
      totalSelectedInvoiceData.totalIrpf7 = (
        totalIrpf7 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 2%
    if (item.irpf === '2') {
      let totalIrpf2 = parseFloat(totalSelectedInvoiceData.totalIrpf2);
      totalSelectedInvoiceData.totalIrpf2 = (
        totalIrpf2 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 1%
    if (item.irpf === '1') {
      let totalIrpf1 = parseFloat(totalSelectedInvoiceData.totalIrpf1);
      totalSelectedInvoiceData.totalIrpf1 = (
        totalIrpf1 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
  });

  // Total Taxes
  totalSelectedInvoiceData.totalTaxes =
    (parseFloat(totalSelectedInvoiceData.totalTax21) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax10) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax4) || 0);

  // Total Irpf
  totalSelectedInvoiceData.totalIrpf =
    (parseFloat(totalSelectedInvoiceData.totalIrpf19) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf15) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf7) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf2) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf1) || 0);

  // Total amount
  totalSelectedInvoiceData.totalAmount = (
    parseFloat(totalSelectedInvoiceData.totalTaxBase) +
    totalSelectedInvoiceData.totalTaxes +
    totalSelectedInvoiceData.totalIrpf
  ).toFixed(2);

  invoice.total_amount = totalSelectedInvoiceData.totalAmount;
  invoice.tax_base = totalSelectedInvoiceData.totalTaxBase;

  return { invoice: invoice, totalData: totalSelectedInvoiceData };
}

export const recursiveStatus = [
  { text: 'Activa', value: 'Activa' },
  { text: 'Pausada', value: 'Pausada' },
  { text: 'Finalizada', value: 'Finalizada' },
];

export const recursiveFrequency = [
  { text: 'Cada año', value: 'anual' },
  { text: 'Cada trimestre', value: 'trimestral' },
  { text: 'Cada mes', value: 'mensual' },
  { text: 'Cada semana', value: 'semanal' },
];

export const recursiveInvoiceType = 'factura_recursiva';
export const recursiveInvoiceTableHeader = [
  { text: 'CONTACTO', value: 'contact_name', align: 'center', sortable: false },
  { text: 'INICIO', value: 'recursive_start', align: 'center', sortable: false },
  { text: 'FRECUENCIA', value: 'recursive_frequency', align: 'center', sortable: false },
  { text: 'PRÓXIMA', value: 'recursive_next', align: 'center', sortable: false },
  { text: 'HASTA', value: 'recursive_end', align: 'center', sortable: false },
  { text: 'ESTADO', value: 'recursive_status', align: 'center', sortable: false },
  { text: 'IMPORTE', value: 'total_amount', align: 'center', sortable: false },
];
